var map = {
	"./active-btn.webp": 2423,
	"./angbao-bonus-thaipusam.webp": 2424,
	"./angbao-bonus.webp": 2425,
	"./angbao-bonus_dewali.webp": 2426,
	"./cny-lucky-draw.webp": 2427,
	"./cny-promo.webp": 2428,
	"./dewali-promo.webp": 2429,
	"./fifa-prediction.webp": 2430,
	"./fifa-qna.webp": 2431,
	"./raya-promo.webp": 2432,
	"./welcome-cny-bonus.webp": 2433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2422;